import { Api } from "./Api";
import { Contact } from "../models/Contact";
import _ from "lodash";
import { Option } from "../models/Option";
import ETag = Contact.ETag;
import Adresse = Contact.Adresse;
import axios from "axios";

export class ContactApi extends Api {
    constructor() {
        super("client");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        // useCache : liste de référence (sélecteurs, filtres) → réponse
        // partagée entre composants ; les tableaux paginés passent
        // useCache=false et interrogent le serveur à chaque fois.
        const shared = !!(params && (<any>params).useCache);
        const request = shared
            ? this.getResourcesShared(params)
            : this.getResources(params);

        return request.then(function (response) {
            var res: Array<Contact> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (d) {
                    return new Contact(d);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    getAllAsOptions(params?: Object): Promise<Array<Option>> {
        // Liste complète attendue : limite explicite (la même que l'app
        // mobile) plutôt que le défaut du serveur.
        params = _.assign({ limit: 100000 }, params);

        return this.getAll(params).then(function (response) {
            return _.map(response.data, function (c) {
                let res = <Option>{
                    id: c.id,
                    name: c.nom,
                };
                if (c.hasTag(ETag.CoproprieteSensible)) {
                    res.classes = "important-tag";
                }
                return res;
            });
        });
    }

    get(id: Number, params?: Object): Promise<Contact> {
        return this.getResource(id, params).then(function (response) {
            return new Contact(response.data.data);
        });
    }

    save(contact: Contact, params?: Object): Promise<Contact> {
        return super
            .saveResource(contact.serialize(), params)
            .then(function (response) {
                return new Contact(response.data.data);
            });
    }

    delete(id: Number, raison?: string): Promise<Contact> {
        return super.deleteResource(id, raison).then(function (response) {
            // Le client supprimé quitte aussi les sélecteurs et les filtres.
            Api.forgetSharedLists();
            return new Contact(response.data.data);
        });
    }

    // Archive client with optional end date for recurring interventions
    archiveWithEndDate(
        contactId: number,
        endDate: string | null
    ): Promise<Contact> {
        const requestBody: any = {};
        if (endDate) {
            requestBody.end_date = endDate;
        }

        return axios
            .post(this.apiUrl + contactId + "/archive", requestBody)
            .then(function (response) {
                return new Contact(response.data.data);
            });
    }

    // Fusion de clients : aperçu avant confirmation (champs à arbitrer,
    // Contacts en doublon, décompte des transferts).
    apercuFusion(conserveId: number, absorbeId: number): Promise<any> {
        return axios
            .get(this.apiUrl + conserveId + "/fusion/" + absorbeId)
            .then(function (response) {
                return response.data.data;
            });
    }

    fusionner(conserveId: number, donnees: Object): Promise<Contact> {
        return axios
            .post(this.apiUrl + conserveId + "/fusion", donnees)
            .then(function (response) {
                // Le client absorbé quitte les sélecteurs et les filtres.
                Api.forgetSharedLists();
                return new Contact(response.data.data);
            });
    }

    // Adresse
    saveAdresse(
        contactId: number,
        adresse: Contact.Adresse,
        params?: Object
    ): Promise<Contact.Adresse> {
        return axios
            .put(this.apiUrl + contactId + "/adresse", adresse, {
                params: params,
            })
            .then(function (response) {
                return response.data.data;
            });
    }
}
